{
  "a-astronaut": {
    "width": 1254,
    "height": 1254,
    "widths": [
      48,
      96,
      192
    ]
  },
  "a-builder": {
    "width": 1254,
    "height": 1254,
    "widths": [
      48,
      96,
      192
    ]
  },
  "a-headphones": {
    "width": 1254,
    "height": 1254,
    "widths": [
      48,
      96,
      192
    ]
  },
  "a-red-cap": {
    "width": 1254,
    "height": 1254,
    "widths": [
      48,
      96,
      192
    ]
  },
  "c-dusk-village": {
    "width": 2243,
    "height": 701,
    "widths": [
      960,
      1600,
      2243
    ]
  },
  "f-nature-kit-v2": {
    "width": 1672,
    "height": 941,
    "widths": [
      640,
      960,
      1440
    ]
  },
  "hero-district": {
    "width": 1915,
    "height": 821,
    "widths": [
      960,
      1600,
      1915
    ]
  },
  "i-roblox-developers": {
    "width": 1254,
    "height": 1254,
    "widths": [
      96,
      192
    ]
  },
  "p-interaction-system": {
    "width": 1448,
    "height": 1086,
    "widths": [
      320,
      640,
      960
    ]
  },
  "p-marketplace-coast-kit": {
    "width": 1586,
    "height": 992,
    "widths": [
      320,
      640,
      960
    ]
  },
  "p-minimal-ui-kit": {
    "width": 1448,
    "height": 1086,
    "widths": [
      320,
      640,
      960
    ]
  },
  "p-modern-lobby-kit": {
    "width": 1448,
    "height": 1086,
    "widths": [
      320,
      640,
      960
    ]
  },
  "p-nature-kit": {
    "width": 1448,
    "height": 1086,
    "widths": [
      320,
      640,
      960
    ]
  },
  "p-tycoon-kit": {
    "width": 1448,
    "height": 1086,
    "widths": [
      320,
      640,
      960
    ]
  },
  "p-vehicle-pack": {
    "width": 1448,
    "height": 1086,
    "widths": [
      320,
      640,
      960
    ]
  },
  "pdp-ui-kit-1": {
    "width": 1586,
    "height": 992,
    "widths": [
      640,
      1280,
      1586
    ]
  },
  "pdp-ui-kit-3": {
    "width": 1586,
    "height": 992,
    "widths": [
      640,
      1280,
      1586
    ]
  },
  "pdp-ui-kit-4": {
    "width": 1586,
    "height": 992,
    "widths": [
      640,
      1280,
      1586
    ]
  }
}
